import { Component } from "react";

class ClientDetails extends Component {
  render() {
    return "ClientDetails";
  }
}

export default ClientDetails;
